module.exports = __webpack_public_path__ + "img/iocn_close.225cbd4b.svg";